import { render, staticRenderFns } from "./AccountSettingSocial.vue?vue&type=template&id=3375c992&"
import script from "./AccountSettingSocial.vue?vue&type=script&lang=js&"
export * from "./AccountSettingSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3375c992')) {
      api.createRecord('3375c992', component.options)
    } else {
      api.reload('3375c992', component.options)
    }
    module.hot.accept("./AccountSettingSocial.vue?vue&type=template&id=3375c992&", function () {
      api.rerender('3375c992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/AccountSettingSocial.vue"
export default component.exports